import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import JsonLd from "@/components/base/JsonLd";

const webPageSchema = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "개인정보처리방침 | 제이아이앤씨 JI&C",
  "description": "제이아이앤씨의 개인정보처리방침. 개인정보 수집 항목, 처리 목적, 보유 기간, 파기 절차 및 이용자 권리에 대한 안내.",
  "url": import.meta.env.VITE_SITE_URL + "/privacy",
  "inLanguage": "ko",
  "isPartOf": {
    "@type": "WebSite",
    "name": "제이아이앤씨 JI&C",
    "url": import.meta.env.VITE_SITE_URL
  }
};

export default function PrivacyPolicy() {
  return (
    <>
      <JsonLd data={webPageSchema} />
      <div className="w-full min-w-[1024px] lg:min-w-0 bg-white text-navy-900">
        <Navbar />
        <main>
          <section className="pt-32 pb-20 px-6 md:px-12 lg:px-16">
            <div className="max-w-4xl mx-auto">
              <h1 className="text-3xl md:text-4xl font-bold text-navy-900 mb-3">
                개인정보처리방침
              </h1>
              <p className="text-sm text-navy-500 mb-10">시행일: 2026년 7월 27일</p>

              <div className="space-y-10 text-sm leading-relaxed text-navy-800">
                <section>
                  <h2 className="text-lg font-semibold text-navy-900 mb-3">제1조 (개인정보의 처리 목적)</h2>
                  <p>
                    주식회사 제이아이앤씨(이하 &apos;회사&apos;)는 다음의 목적을 위하여 개인정보를 처리합니다.
                    처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는
                    「개인정보 보호법」 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.
                  </p>
                  <ul className="list-disc pl-5 mt-2 space-y-1 text-navy-700">
                    <li>고객 상담 및 문의 응대</li>
                    <li>견적 요청 및 서비스 안내</li>
                    <li>계약 이행 및 공사 관련 연락</li>
                    <li>하자 보수 및 사후 관리</li>
                  </ul>
                </section>

                <section>
                  <h2 className="text-lg font-semibold text-navy-900 mb-3">제2조 (수집하는 개인정보 항목)</h2>
                  <p>회사는 서비스 제공을 위하여 다음과 같은 개인정보를 수집하고 있습니다.</p>
                  <ul className="list-disc pl-5 mt-2 space-y-1 text-navy-700">
                    <li>
                      <strong>필수 항목:</strong> 성명, 연락처(전화번호, 이메일), 상담 내용
                    </li>
                    <li>
                      <strong>선택 항목:</strong> 회사명, 주소, 공사 희망 위치
                    </li>
                    <li>
                      <strong>자동 수집 항목:</strong> 서비스 이용 기록, 접속 로그, 쿠키, 접속 IP 정보
                    </li>
                  </ul>
                </section>

                <section>
                  <h2 className="text-lg font-semibold text-navy-900 mb-3">제3조 (개인정보의 처리 및 보유 기간)</h2>
                  <p>회사는 법령에 따른 개인정보 보유·이용 기간 또는 정보주체로부터 개인정보를 수집 시에 동의 받은 개인정보 보유·이용 기간 내에서 개인정보를 처리·보유합니다.</p>
                  <ul className="list-disc pl-5 mt-2 space-y-1 text-navy-700">
                    <li>고객 상담 및 문의 기록: 3년</li>
                    <li>계약 관련 정보: 5년 (상법에 따른 상사채권 소멸시효)</li>
                    <li>하자 보수 기록: 5년</li>
                    <li>접속 로그: 3개월 (통신비밀보호법)</li>
                  </ul>
                </section>

                <section>
                  <h2 className="text-lg font-semibold text-navy-900 mb-3">제4조 (개인정보의 제3자 제공)</h2>
                  <p>
                    회사는 정보주체의 개인정보를 제1조에서 명시한 범위 내에서만 처리하며, 정보주체의 동의, 법률의 특별한 규정 등
                    「개인정보 보호법」 제17조 및 제18조에 해당하는 경우에만 개인정보를 제3자에게 제공합니다.
                  </p>
                </section>

                <section>
                  <h2 className="text-lg font-semibold text-navy-900 mb-3">제5조 (개인정보처리의 위탁)</h2>
                  <p>
                    회사는 원활한 서비스 제공을 위하여 다음과 같이 개인정보 처리 업무를 외부에 위탁하고 있지 않습니다.
                    향후 위탁 계약 체결 시 개인정보보호법 제26조에 따라 위탁 업무 수행 목적 외 개인정보 처리 금지,
                    기술적·관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리·감독, 손해배상 등 책임에 관한 사항을 계약서 등
                    문서에 명시하고, 수탁자가 개인정보를 안전하게 처리하는지 감독할 예정입니다.
                  </p>
                </section>

                <section>
                  <h2 className="text-lg font-semibold text-navy-900 mb-3">제6조 (정보주체의 권리·의무 및 행사방법)</h2>
                  <p>
                    정보주체는 회사에 대해 언제든지 개인정보 열람·정정·삭제·처리정지 요구 등의 권리를 행사할 수 있습니다.
                    권리 행사는 회사에 대해 서면, 전화, 이메일 등을 통하여 하실 수 있으며,
                    회사는 이에 대해 지체 없이 조치하겠습니다. 권리 행사는 정보주체의 법정대리인이나 위임을 받은 자 등 대리인을 통하여 하실 수도 있습니다.
                  </p>
                </section>

                <section>
                  <h2 className="text-lg font-semibold text-navy-900 mb-3">제7조 (개인정보의 파기 절차 및 방법)</h2>
                  <p>
                    회사는 개인정보 보유 기간의 경과, 처리 목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체 없이
                    해당 개인정보를 파기합니다. 파기 절차 및 방법은 다음과 같습니다.
                  </p>
                  <ul className="list-disc pl-5 mt-2 space-y-1 text-navy-700">
                    <li>
                      <strong>파기 절차:</strong> 파기 사유가 발생한 개인정보를 선정하고, 개인정보 보호책임자의 승인을 받아 파기합니다.
                    </li>
                    <li>
                      <strong>파기 방법:</strong> 전자적 파일 형태의 정보는 복구 및 재생이 불가능한 기술적 방법을 사용하여 파기하며,
                      종이 문서는 분쇄하거나 소각하여 파기합니다.
                    </li>
                  </ul>
                </section>

                <section>
                  <h2 className="text-lg font-semibold text-navy-900 mb-3">제8조 (개인정보의 안전성 확보 조치)</h2>
                  <p>회사는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다.</p>
                  <ul className="list-disc pl-5 mt-2 space-y-1 text-navy-700">
                    <li>개인정보 취급 직원의 최소화 및 교육</li>
                    <li>개인정보에 대한 접근 권한 관리</li>
                    <li>접속 기록의 보관 및 위·변조 방지</li>
                    <li>개인정보의 암호화 등 보안 프로그램 설치 및 운영</li>
                    <li>해킹 등 외부 침입에 대비한 기술적·물리적 보안 대책</li>
                  </ul>
                </section>

                <section>
                  <h2 className="text-lg font-semibold text-navy-900 mb-3">제9조 (개인정보 보호책임자)</h2>
                  <p>
                    회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만 처리 및
                    피해 구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.
                  </p>
                  <div className="mt-3 p-4 bg-navy-50 rounded-lg space-y-1">
                    <p><strong>개인정보 보호책임자:</strong> 김성현</p>
                    <p><strong>연락처:</strong> 051-727-0477</p>
                    <p><strong>이메일:</strong> ksh10090000@hanmail.net</p>
                    <p><strong>주소:</strong> 부산시 기장군 장안읍 좌천로 20, 101호</p>
                  </div>
                </section>

                <section>
                  <h2 className="text-lg font-semibold text-navy-900 mb-3">제10조 (권익침해 구제 방법)</h2>
                  <p>
                    정보주체는 개인정보 침해로 인한 구제를 받기 위하여 개인정보분쟁조정위원회, 한국인터넷진흥원
                    개인정보침해신고센터 등에 분쟁 해결이나 상담 등을 신청할 수 있습니다.
                  </p>
                  <ul className="list-disc pl-5 mt-2 space-y-1 text-navy-700">
                    <li>개인정보분쟁조정위원회: 1833-6972 (www.kopico.go.kr)</li>
                    <li>개인정보침해신고센터: 118 (privacy.kisa.or.kr)</li>
                    <li>대검찰청 사이버범죄수사단: 1301 (www.spo.go.kr)</li>
                    <li>경찰청 사이버안전국: 182 (cyberbureau.police.go.kr)</li>
                  </ul>
                </section>

                <section>
                  <h2 className="text-lg font-semibold text-navy-900 mb-3">제11조 (개인정보처리방침 변경)</h2>
                  <p>
                    이 개인정보처리방침은 2026년 7월 27일부터 적용됩니다. 법령 및 방침에 따른 변경 내용의 추가, 삭제 및 정정이
                    있는 경우에는 변경 사항의 시행 7일 전부터 공지사항을 통하여 고지할 것입니다.
                  </p>
                </section>
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
}